import m from 'moment';
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
import 'moment/locale/sv';
import 'moment/locale/en-gb';

Moment.locale('sv');
Moment.localeData('sv');

export const timezone = 'Europe/Stockholm';
export const testTimestamp = 1514764800000; // 2018-01-01T00:00:00+00:00

const moment = extendMoment(Moment);

moment.tz.setDefault(timezone);

// https://github.com/moment/moment-timezone/issues/647#issuecomment-439600573
m.locale('sv');
moment.updateLocale('sv', m.localeData()._config);
moment.locale('sv');

export default moment;
